/*
 * @Author: sail web admin
 * @Date: 2020-04-26 18:07:48
 * @Last Modified by: sail web admin
 * @Last Modified time: 2020-09-27 17:18:24
 * 共用英文
 */

export default {
  Yes: 'Yes',
  No: 'No',
  Operate: 'Operate',
  PleaseEnter: 'Please enter ',
  PleaseChoose: 'Please choose ',
  Inquire: 'Inquire',
  Reset: 'Reset',
  Submit: 'Submit',
  New: 'New',
  Ok: 'Ok',
  Cancel: 'Cancel',
  Edit: 'edit',
  Delete: 'delete',
  Detail: 'detail',
  Welcome: 'Welcome',
  SignIn: 'Sign in',
  SignOut: 'Sign out',
  Close: 'Close',
  All: 'All',
  Export: 'Export',
  Collapse: 'Collapse',
  Expand: 'Expand',
  Upload: 'Upload',
  Formart: 'Formart',
  As: 'as ',
  Enter: 'enter',
  SureTo: 'Sure to',
  NoData: 'No data!',
  Refresh: 'Refresh',
  Add: 'Add',
  Modify: 'modify',
  OperateSuccess: 'Opreate success',
  OperateFail: 'Operate fail',
  NetworkFail: 'Network error. Please try again later',
  LoginExpired: 'The current user login information has expired, please login again!',
  ServerException: 'The Server side exception, please login again!',
  ServerExceptionTryAgain: 'The Server side exception, please reload page!'
};
